import { createCpraConsentTracker } from './CpraConsent';
import { createGdprConsentTracker, getGdprConsentStatus } from './GdprConsent';

// These legacy SDK helpers retain their GDPR semantics for compatibility.
export {
  configureGdprConsent as configureConsent,
  getGdprConsentCookieName as getConsentCookieName,
  isGdprConsentCookieSet as isConsentCookieSet,
} from './GdprConsent';
export { saveConsentStatus } from './ConsentStorage';

const isCpra = status => status?.regulation?.toLowerCase() === 'cpra';

const getEnabledIds = statusMap =>
  Object.keys(statusMap || {}).filter(id => statusMap[id]?.enabled === true);

export const createConsentDetails = (status, moduleName, moduleVersion) => ({
  sourceFrontendModule: moduleName || 'UNKNOWN',
  sourceFrontendModuleVersion: moduleVersion || 'UNKNOWN',
  regulationName: status?.regulation?.toUpperCase() || 'UNKNOWN',
  purposesConsent: getEnabledIds(status?.purposes),
  vendorsConsent: getEnabledIds(status?.vendors),
});

export const getConsentStatus = didomiUtils => {
  const currentStatus = didomiUtils.getCurrentUserStatusFromDidomi();
  if (isCpra(currentStatus)) {
    return currentStatus;
  }
  return getGdprConsentStatus(didomiUtils, currentStatus);
};

export const createConsentTracker = ({
  notifyConsentChange,
  hasConsentCookie,
  notifyExistingConsent,
}) => {
  const cpraConsent = createCpraConsentTracker(notifyConsentChange);
  const gdprConsent = createGdprConsentTracker({
    hasConsentCookie,
    notifyExistingConsent,
  });
  const getTracker = status => (isCpra(status) ? cpraConsent : gdprConsent);
  // A notice can precede SDK readiness, before its regulation is available.
  let noticeShown = false;

  return {
    onReady(status) {
      getTracker(status).onReady(status, noticeShown);
    },
    onNoticeShown(status) {
      noticeShown = true;
      getTracker(status).onNoticeShown(status);
    },
    shouldNotifyConsentChange(status) {
      return getTracker(status).shouldNotifyConsentChange(status);
    },
  };
};
